export default {
  GENERAL: 'general',
  SAMPLE: 'sample',
  METHOD_PARAMETERS: 'method-parameters',
  ALARM_LEVEL_PARAMETERS: 'alarm-level-parameters',
};
